import { ArrowLeft, Globe } from "@phosphor-icons/react";
import { format } from "date-fns";
import { useParams } from "react-router-dom";
import { useActivityDataDetail } from "../api/activity-data";
import AppLink from "../components/AppLink";
import ContentContainer from "../components/ContentContainer";
import IconButton from "../components/IconButton";
import MainLayout from "../components/MainLayout";
import Separator from "../components/Separator";
import Tag from "../components/Tag";
import Typography from "../components/Typography";
import { appPaths } from "../Routes";
import { RequireEmissionsSourceEvidenceTable } from "../components/RequiredEvidenceTable";
import SectionTitle from "../components/SectionTitle";
import ActivityDataCalculationCard from "../components/ActivityDataCalculationCard";

const ActivityDataPointPage = () => {
    const { id } = useParams();
    const { activityData, isLoading } = useActivityDataDetail(Number(id));

    if (!id) return null;

    return (
        <MainLayout isLoading={isLoading}>
            {!activityData && (
                <ContentContainer className="py-10 text-center">
                    <p>No activity data found matching this id</p>
                </ContentContainer>
            )}
            {activityData && (
                <ContentContainer className="pt-14 pb-11 max-w-7xl">
                    <div className="flex flex-col gap-6 sm:flex-row sm:items-center pb-5">
                        <div className="flex items-center">
                            <IconButton
                                label="Back"
                                icon={ArrowLeft}
                                iconSize="large"
                                className="mr-3"
                                onClick={() => window.history.back()}
                            />
                            <Typography
                                variant="headline-small"
                                component="h1"
                                className="mr-3"
                            >
                                Activity Data Point
                            </Typography>
                        </div>
                        <div className="flex items-center flex-1 justify-between">
                            {activityData.emissionsFactors.length > 0 ? (
                                <Tag variant="success">Complete</Tag>
                            ) : (
                                <Tag variant="error">Incomplete</Tag>
                            )}
                            <div className="ml-auto flex items-center gap-2 font-semibold">
                                <Globe weight="light" size={24} />
                                <Typography
                                    variant="headline-small"
                                    component="span"
                                    className="text-deep-ocean-20"
                                >
                                    Scope {activityData?.scope}
                                </Typography>
                            </div>
                        </div>
                    </div>
                    <Separator className="mb-8" />
                    <Typography variant="body-large" component="p">
                        <b>Activity Period:</b>{" "}
                        {format(
                            new Date(activityData.activityStartDate),
                            "dd/MM/yyyy"
                        )} - {format(
                            new Date(activityData.activityEndDate),
                            "dd/MM/yyyy"
                        )}
                    </Typography>
                    <Typography variant="body-large" component="p">
                        <b>Location:</b> {activityData.locationName}
                    </Typography>
                    <Typography variant="body-large" component="p">
                        <b>Data Source:</b>{" "}
                        <AppLink
                            to={appPaths.dataSourceDetail(
                                activityData.dataSourceId.toString()
                            )}
                        >
                            {activityData.dataSourceName}
                        </AppLink>
                    </Typography>
                    <SectionTitle title="Emissions" />
                    <ActivityDataCalculationCard {...activityData} />
                    <RequireEmissionsSourceEvidenceTable
                        defaultStatusFilter="All"
                        emissionsSourceId={activityData.emissionsSourceId}
                        activityDataId={activityData.id}
                        noEvidenceMessage="No evidence found"
                        readonly={true}
                        title="Emissions Source Evidence"
                    />
                </ContentContainer>
            )}
        </MainLayout>
    );
};

export default ActivityDataPointPage;
